import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { RootComponent } from './components/root/root.component';
import { MicrosoftLoginRedirectionComponent } from './modules/auth/microsoft-login-redirection/microsoft-login-redirection.component';
import { AuthGuard } from './guard/auth.guard';


let routes: Routes = [
    { path: 'auth/loginauth', component: MicrosoftLoginRedirectionComponent },
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

    {
        path: '',
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'compact',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        children: [
            // {
            //     path: '',
            //     pathMatch: 'full',
            //     component: PageHomeOneComponent
            // },
            {
                path: 'checkcoverage',
                loadChildren: () => import('./modules/enroll/enroll.module').then(m => m.EnrollModule)
            },
            {
                path: 'fibre',
                loadChildren: () => import('./modules/fiber/fiber.module').then(m => m.FiberModule)
            },
            {
                path: 'landing',
                loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./modules/homePage/home.module').then(m => m.HomeModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/reseller/reseller.module').then(m => m.ResellerModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/Billing/billing.module').then(m => m.BillingModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
            },
            {
                path: 'support',
                loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule),
            },
            {
                path: 'profile/:id',
                loadChildren: () => import('./modules/my-account/my-account.module').then(m => m.MyAccountModule),
            },
            {
                path: 'managerequest',
                loadChildren: () => import('./modules/manage-queries/manage-queries.module').then(m => m.ManageQueriesModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/manage-ticket/manage-ticket.module').then(m => m.ManageTicketModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/Additional-Features/Additional-Features.module').then(m => m.AdditionalFeaturesModule),
            },
            {
                path: '',
                loadChildren: () => import('./modules/Manage-Application/manage-application.module').then(m => m.ManageApplicationModule),
            },
        ]
    },
    {
        path: 'auth',
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'compact',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'main',
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'compact',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'error',
        component: PageNotFoundComponent
    },
    { path: '**', redirectTo: 'error', pathMatch: 'full' },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        initialNavigation: 'enabled',
        relativeLinkResolution: 'legacy'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
